import { render, staticRenderFns } from "./customRegister.vue?vue&type=template&id=28c9e58e&scoped=true&"
import script from "./customRegister.vue?vue&type=script&lang=js&"
export * from "./customRegister.vue?vue&type=script&lang=js&"
import style0 from "./customRegister.vue?vue&type=style&index=0&id=28c9e58e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9e58e",
  null
  
)

export default component.exports